import { useRoutes } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import { useSelector } from 'react-redux';
import { userInfoSelectUserInfo } from '@/store/auth/selectors';
export default function ThemeRoutes() {
    var userInfo = useSelector(userInfoSelectUserInfo);
    var isAuthenticated = useSelector(function (state) { return state.auth; }).isAuthenticated;
    return useRoutes([
        MainRoutes(isAuthenticated, userInfo),
        LoginRoutes(userInfo),
    ]);
}
